const DOCUMENT_LOAD_SEQUENCE_KEY = "afrimed:onboarding-document-load-sequence";

let cachedDocumentContext = null;

function safeSessionStorage() {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

function nextDocumentLoadSequence(storage) {
  const previous = Number.parseInt(storage?.getItem(DOCUMENT_LOAD_SEQUENCE_KEY) || "0", 10);
  const next = Number.isFinite(previous) && previous >= 0 ? previous + 1 : 1;
  try {
    storage?.setItem(DOCUMENT_LOAD_SEQUENCE_KEY, String(next));
  } catch {
    // Diagnostic-only state must never interrupt onboarding.
  }
  return next;
}

function createOpaqueDocumentId() {
  try {
    return globalThis.crypto?.randomUUID?.() || `document-${Date.now()}-${Math.random().toString(36).slice(2)}`;
  } catch {
    return `document-${Date.now()}`;
  }
}

export function getPrivacySafeTelemetryRoute(locationLike = globalThis.location) {
  const pathname = String(locationLike?.pathname || "/").trim();
  return pathname.startsWith("/") && !pathname.startsWith("//") ? pathname : "/";
}

export function getDocumentNavigationTelemetry() {
  if (cachedDocumentContext) return cachedDocumentContext;

  const storage = safeSessionStorage();
  let navigationType = "unknown";
  try {
    const entry = globalThis.performance?.getEntriesByType?.("navigation")?.[0];
    const type = String(entry?.type || "").trim();
    if (["navigate", "reload", "back_forward", "prerender"].includes(type)) {
      navigationType = type;
    }
  } catch {
    // Navigation Timing is optional and may be unavailable in privacy-restricted browsers.
  }

  cachedDocumentContext = {
    document_load_id: createOpaqueDocumentId(),
    document_load_sequence: nextDocumentLoadSequence(storage),
    navigation_type: navigationType,
  };
  return cachedDocumentContext;
}
